import { WifiOff, Signal } from "lucide-react";
import { useNetwork } from "../context/NetworkContext";

export default function NetworkBanner() {
  const { status, isOnline } = useNetwork();

  if (isOnline) return null;

  const isOffline = status === "offline";

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium transition-all duration-300 ${
        isOffline
          ? "bg-[#514a3f] text-[#f0ede4]"
          : "bg-[#dfa625]/90 text-[#3a3728]"
      }`}
      data-testid="network-banner"
    >
      {isOffline ? (
        <>
          <WifiOff size={14} strokeWidth={2} />
          <span>You're offline — your scores are saved locally</span>
        </>
      ) : (
        <>
          <Signal size={14} strokeWidth={2} />
          <span>Weak signal — saving locally, will sync when stable</span>
        </>
      )}
    </div>
  );
}
